import React from 'react';
import styled from 'styled-components';
import { TComponentB2WMessage, TComponentDeliveryMessage } from './interfaces';

export const B2WMessage: TComponentB2WMessage = ({ brandName }) => (
  <p>
    Este produto é vendido e entregue por <strong>{brandName}</strong>.
  </p>
);

export const B2WDeliveryMessage: TComponentDeliveryMessage = ({ seller, brandName, linkKnowMore }) => {
  const { id, name } = seller;
  const isAmericanas = brandName === 'Americanas';

  return (
    <p>
      Este produto é vendido por <Link href={`/lojista/${id}`}>{name}</Link> e entregue por&nbsp;
      <strong>{brandName}</strong>, que garante a sua compra, do pedido à entrega.&nbsp;
      {isAmericanas && knowMore(linkKnowMore)}
    </p>
  );
};

export const SellerDeliveryMessage: TComponentDeliveryMessage = ({ seller, brandName, linkKnowMore, isDigital }) => {
  const { id, name } = seller;
  const isAmericanas = brandName === 'Americanas';
  const warrantyStatement = isDigital ? 'garante sua entrega digital' : 'garante a sua compra, do pedido à entrega';

  return (
    <p>
      Este produto é vendido e entregue por <Link href={`/lojista/${id}`}>{name}</Link>. {isAmericanas ? 'A' : 'O'}
      &nbsp;<strong>{brandName}</strong>
      &nbsp;{warrantyStatement}.&nbsp;
      {isAmericanas && knowMore(linkKnowMore)}
    </p>
  );
};

export const knowMore = (linkKnowMore: string) => (
  <Link target="_blank" href={linkKnowMore}>
    saiba mais
  </Link>
);

const Link = styled.a`
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;
